import React from "react";
import { Box, CircularProgress } from "@mui/material";
import CallsFilterCard from "./CallsFilterCard";
import GraphCard from "./GraphCard";
import DoctorStats from "./DoctorStats";
import { useSalesContext } from "../../SalesContext";
import useFilterOptions from "./useFilterOptions";

interface MainDoctorCoverageComponentProps {
  user_id: string;
}

const MainDoctorCoverageComponent: React.FC<
  MainDoctorCoverageComponentProps
> = ({ user_id }) => {
  const { kpiData } = useSalesContext();
  const { filterOptions, isLoading, error } = useFilterOptions(user_id || "");

  const complianceStats = kpiData?.progressChart?.complianceStats || {
    uniqueVisits: 0,
    associated: 0,
    categories: [],
    speciality: [],
    frequency: [],
  };
  const missedStats = kpiData?.progressChart?.missedStats || {
    missedDoctor: 0,
    missedCalls: 0,
    categories: [],
    speciality: [],
    frequency: [],
  };

  if (isLoading || !kpiData) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Error: {error}
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3, p: 2 }}>
      <CallsFilterCard filterOptions={filterOptions} />
      <GraphCard />
      <DoctorStats
        compliance={complianceStats.uniqueVisits}
        associated={complianceStats.associated}
        isLimited={false}
        categories={complianceStats.categories}
        speciality={complianceStats.speciality}
        frequency={complianceStats.frequency}
      />
      <DoctorStats
        missedDoctor={missedStats.missedDoctor}
        missedCalls={missedStats.missedCalls}
        isLimited={true}
        categories={missedStats.categories}
        speciality={missedStats.speciality}
        frequency={missedStats.frequency}
      />
    </Box>
  );
};

export default MainDoctorCoverageComponent;
